import React from 'react';
import ProductHeaderViewMobile from '../ProductHeaderViewMobile';
import main from '../../resource/lis_mobile/main.png';

const MainMobile = () => {
    return (
        <ProductHeaderViewMobile
            title="LIS"
            description="Cloud based. No requiere instalación y puede ser utilizado con recursos mínimos. Soportamos sistemas operativos Linux y Windows. Software de ultima generación pensado para cubrir todas las necesidades de tu laboratorio. Facilita la experiencia del usuario en cada etapa del proceso con un diseño amigable y moderno, acompañanado el crecimiento de tu negocio."
            image={main} />
    );
};

export default MainMobile;